import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "text-xs font-medium text-catering-ink-800" }
const _hoisted_3 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_4 = { class: "min-w-0 truncate" }
const _hoisted_5 = { class: "shrink-0 tabular-nums text-catering-ink-500" }
const _hoisted_6 = {
  key: 0,
  class: "py-1 text-catering-ink-400"
}


export default {
  __name: 'BotCategoryList',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Categories", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.stores || [], (s, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "mb-2 last:mb-0"
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(s.store_name), 1),
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.categories || [], (c, j) => {
            return (_openBlock(), _createElementBlock("li", {
              key: j,
              class: "flex items-center justify-between py-1 text-catering-ink-900"
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(c.name), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(c.product_count), 1)
            ]))
          }), 128)),
          (!(s.categories || []).length)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, "No categories yet"))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

}